import { TOKEN, GEOCODER_ZOOM } from './constants';

export const geocoder = new MapboxGeocoder({
  accessToken: TOKEN,
  countries: 'us',
  region: 'ca',
  placeholder: 'Enter an address',
  marker: false,
  zoom: GEOCODER_ZOOM,
  bbox: [-121.543, 31.703, -112.919, 35.414],
});
